import script from "./IdeaActivityUpdateNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdeaActivityUpdateNotification.vue?vue&type=script&setup=true&lang=ts"

import "./IdeaActivityUpdateNotification.vue?vue&type=style&index=0&id=6d09fe17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d09fe17"]])

export default __exports__